ko.components.register('notifications', {
	viewModel: function(params){
		var self = this;

		self.title = ko.observable(params && params.title || 'Notifications');
		self.markAsReadLabel = ko.observable(params && params.markAsReadLabel || 'Mark As Read');
		self.emptyText = ko.observable(params && params.emptyText || 'No messages yet');
		self.items = ko.observableArray(params && params.items);
		self.unreadItems = ko.pureComputed(function(){
			return self.items().filter(function(i){ return i.isUnread() == 1; });
		});
		self.time = ko.observable(parseInt(params && params.time || 0));
		self.open = ko.observable(false);

		self.loading = ko.observable(false);

		self.ajaxRequest = function(action, params, callback){
			if(self.loading())
				return;
			self.loading(true);
			return App.ajaxRequest('notifications/' + action, params, callback).always(function(){ self.loading(false); });
		};

		self.itemRead = function(item){
			if(item.isUnread())
				self.ajaxRequest('read', {items: [item.id()]}, function(r){
			    	if(r && r.ok) {
			    		item.unread(0);
			    	}
			    });
		};

		self.markRead = function(){
			var ids = [];
			ko.utils.arrayForEach(self.unreadItems(), function(item) {
				if(item.isUnread())
					ids.push(item.id());
		    });
		    self.ajaxRequest('read', {items: ids}, function(r){
		    	if(r && r.ok) {
					ko.utils.arrayForEach(self.unreadItems(), function(item) {
			    		item.unread(0);
			    	});
		    	}
		    });
		};

		self.loadItems = function(){
			self.ajaxRequest('list', {time: self.time()}, function(r){
				if(r) {
					if(r.ok) {
						if(r.items)
							for(var k in r.items)
							{
								if(self.time() < parseInt(r.items[k].time))
									self.items.unshift(new Notification(r.items[k]));
							}
						if(r.time)
							self.time(parseInt(r.time));
					}
					if(r.error)
						alert(r.error);
				}
			});
		};

	    self.toggle = function() {
			self.open(!self.open());
			if(!self.open())
				return;
			if(self.open())
				self.loadItems();
		};

		// TODO: need better items update algo

		if(!window.notificationsUpdater)
		{
			self.loadItems();

			window.notificationsUpdater = setInterval(function(){
				self.loadItems();
			}, 5000);
		}
	},
	template: "<a href=\"#notifications\" class=\"notifications-button\" data-bind=\"css: {\n\t'open': open(),\n\t'has-unread': unreadItems().length\n\t}, click: toggle\">\n\t<span class=\"ic ic-bell\"></span>\n\t<small class=\"badge badge-pill badge-warning\" data-bind=\"visible: unreadItems().length, text: unreadItems().length\"></small>\n</a>\n<div class=\"notifications border-primary\" data-bind=\"visible: open()\">\n\t<div class=\"notifications-body\">\n\t\t<div class=\"list-group\">\n\t\t\t<div class=\"list-group-item active\">\n\t\t\t\t<a href=\"#hide\" class=\"text-light float-right\" data-bind=\"click: toggle\"><span class=\"ic ic-remove\"></span></a>\n\t\t\t\t<span class=\"ic ic-bell\"></span>\n\t\t\t\t<span data-bind=\"text: title()\"></span>\n\t\t\t\t<small class=\"ml-2\"><a class=\"text-light\" href=\"#read\" data-bind=\"visible: unreadItems().length, click: markRead, text: markAsReadLabel()\"></a></small>\n\t\t\t\t<span class=\"spinner-border spinner-border-light spinner-border-sm\" data-bind=\"visible: loading()\"></span>\n\t\t\t</div>\n\t\t\t<div class=\"list-group-item\" data-bind=\"visible: !items().length\">\n\t\t\t\t<small class=\"text-muted\" data-bind=\"text: emptyText\"></small>\n\t\t\t</div>\n\t\t\t<div class=\"notifications-items\" data-bind=\"foreach: items()\">\n\t\t\t\t<div class=\"list-group-item\" data-bind=\"css: {\n\t\t\t\t\t'text-warning': type() == 'warning',\n\t\t\t\t\t'text-success': type() == 'success',\n\t\t\t\t\t'text-danger': type() == 'error',\n\t\t\t\t\t'list-group-item-action': isUnread()\n\t\t\t\t\t}, click: $parent.itemRead\">\n\t\t\t\t\t<small class=\"text-muted\" data-bind=\"text: created()\"></small>\n\t\t\t\t\t<div data-bind=\"css: {'unread font-weight-bold': isUnread()}, html: content()\"></div>\n\t\t\t\t\t<small class=\"text-muted\" data-bind=\"visible: source().length, html: source()\"></small>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"
});